import { render, staticRenderFns } from "./PurchasesPaymentListTable.vue?vue&type=template&id=14725268"
import script from "./PurchasesPaymentListTable.vue?vue&type=script&lang=js"
export * from "./PurchasesPaymentListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports